import {
  Box,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import { useState } from "react";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import Card from "../../../components/Card";
import { getTranslation } from "../../../heplers/translationHelper";
import ButtonWithLoading from "../../../components/ButtonWithLoading";
import { MyDialog } from "../../../components/Dialog";
import { Get } from "../../../actions";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { CountrySelection } from "../../../constants/countries";

const Add = ({ formData, open, onSubmit, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, getTranslation("First Name must only contain letters"))
    .required(getTranslation("First Name is required")),
  
  lastName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, getTranslation("Last Name must only contain letters"))
    .required(getTranslation("Last Name is required")),
  
    country: Yup.string().required(getTranslation("Country is required")),
    address1: Yup.string().required(getTranslation("Address is required")),
    zipCode: Yup.string()
      .required(getTranslation("Zip is required"))
      .matches(/^[0-9]+$/, getTranslation("Must be only digits")),
    town: Yup.string().required(getTranslation("Town is required")),
    vat: Yup.string().required(getTranslation("VAT is required")),
    phone: Yup.string()
      .required(getTranslation("Phone is required"))
      .matches(/^[0-9]+$/, getTranslation("Must be only digits")),
    email: Yup.string()
      .email()
      .required(getTranslation("Please enter a valid email address")),
    password: Yup.string()
      .min(6, getTranslation("Password atleast 6 character long"))
      .required(getTranslation("Password is required")),
    confirmPassword: Yup.string()
      .min(6, getTranslation("Password atleast 6 character long"))
      .oneOf([Yup.ref("password"), null], getTranslation("Passwords must match")),
    website: Yup.string()
      .matches(
        /^(?!:\/\/)([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/,
        getTranslation("Enter a valid site like \"example.com\"")
      )
      .required(getTranslation("Website is required")),
  });

  const updateValidationSchema = Yup.object().shape({
    firstName: Yup.string().required(getTranslation("First Name is required")),
    lastName: Yup.string().required(getTranslation("Last Name is required")),
    country: Yup.string().required(getTranslation("Country is required")),
    address1: Yup.string().required(getTranslation("Address is required")),
    zipCode: Yup.string()
      .required(getTranslation("Zip is required"))
      .matches(/^[0-9]+$/, getTranslation("Must be only digits")),
    vat: Yup.string().required(getTranslation("VAT is required")),
    town: Yup.string().required(getTranslation("Town is required")),
    phone: Yup.string()
      .required(getTranslation("Phone is required"))
      .matches(/^[0-9]+$/, getTranslation("Must be only digits"))
      .min(10, getTranslation("Must be at least 10 digits")),
    email: Yup.string()
      .email()
      .required(getTranslation("Please enter a valid email address")),

    website: Yup.string()
      .matches(
        /^(?!:\/\/)([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/,
        getTranslation("Enter a valid site like \"example.com\"")
      )
      .required(getTranslation("Website is required")),
  });

  // const submit = (data, actions) => {
  // 	actions.setSubmitting(true);
  // 	Post(
  // 		data,
  // 		Upsert_Customers_URL,
  // 		null,
  // 		(res) => {
  // 			actions.setSubmitting(false);
  // 			setIsEdit(false);
  // 			enqueueSnackbar(
  // 				isEdit
  // 					? getTranslation(
  // 							"Updated successfully",
  // 							"Updated successfully",
  // 							"Updated successfully"
  // 					  )
  // 					: getTranslation(
  // 							"Customer created successfully",
  // 							"Customer created successfully",
  // 							"Customer created successfully"
  // 					  ),
  // 				{
  // 					variant: "success",
  // 				}
  // 			);
  // 			setParams({ ...params, pageNumber: 0 });
  // 			setFormData({
  // 				fullName: "",
  // 				email: "",
  // 				phone: "",
  // 				subscribeForNews: false,
  // 			});
  // 		},
  // 		(err) => {
  // 			actions.setSubmitting(false);
  // 			if (!err || !err.data) return;
  // 			enqueueSnackbar(
  // 				err?.data
  // 					? err?.data
  // 					: getTranslation(
  // 							"Something went wrong. Please try Again",
  // 							"Something went wrong. Please try Again",
  // 							"Something went wrong. Please try Again"
  // 					  ),
  // 				{
  // 					variant: "error",
  // 				}
  // 			);
  // 		}
  // 	);
  // };

  const defaultData = formData?.id
    ? {
        ...formData,
        ...formData.owner,
      }
    : {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        name: "",
        vat: "",
        description: "",
        website: "",
        packageType: 0,
        role: "manager",
        country: "",
        address1: "",
        zipCode: "",
        town: "",
        phone: "",
      };

  return (
    <MyDialog
      title={
        formData?.id
          ? getTranslation("Edit Customers", "Edit Customers", "Edit Customers")
          : getTranslation("Add Customers", "Add Customers", "Add Customers")
      }
      onClose={onClose}
      open={open}
    >
      <Card>
        <CardContent>
          <Formik
            initialValues={defaultData}
            enableReinitialize
            validationSchema={
              formData?.id ? updateValidationSchema : validationSchema
            }
            onSubmit={(values, actions) => {
              actions.setSubmitting(true);
              const submitValues = { ...values };

              if (formData?.id) {
                delete submitValues.password;
                delete submitValues.confirmPassword;
              }

              onSubmit(submitValues, actions);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
              isSubmitting,
              setFieldError,
            }) => {
              console.log("Formik Values:", values);
              return (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={12}>
                      <Box display="flex" justifyContent="center">
                        {/* <ToggleButtonGroup
                          exclusive
                          value={values.packageType}
                          onChange={(e, value) => {
                            if (value != null && !formData?.id)
                              setFieldValue("packageType", value);
                          }}
                          disabled={Boolean(formData?.id)} 
                        >
                          <ToggleButton value={0}>Free</ToggleButton>
                          <ToggleButton value={1}>Subscription</ToggleButton>
                        </ToggleButtonGroup> */}
                      </Box>
                    </Grid>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation(
                          "First Name",
                          "First Name",
                          "First Name"
                        )}
                        name="firstName"
                        type="string"
                        size="small"
                        value={values.firstName}
                        onChange={handleChange}
                        error={touched.firstName && Boolean(errors.firstName)}
                        helperText={touched.firstName && errors.firstName}
                        inputProps={{
                          pattern: "^[A-Za-z\\s]+$",
                          onKeyPress: (event) => {
                            const charCode = event.charCode;
                            if (
                              !/[A-Za-z\s]/.test(String.fromCharCode(charCode))
                            ) {
                              event.preventDefault();
                            }
                          },
                        }}
                      />
                    </Grid>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation(
                          "Last Name",
                          "Last Name",
                          "Last Name"
                        )}
                        name="lastName"
                        type="string"
                        size="small"
                        value={values.lastName}
                        onChange={handleChange}
                        error={touched.lastName && Boolean(errors.lastName)}
                        helperText={touched.lastName && errors.lastName}
                        inputProps={{
                          pattern: "^[A-Za-z\\s]+$",
                          onKeyPress: (event) => {
                            const charCode = event.charCode;
                            if (
                              !/[A-Za-z\s]/.test(String.fromCharCode(charCode))
                            ) {
                              event.preventDefault();
                            }
                          },
                        }}
                      />
                    </Grid>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation("Email", "Email", "Email")}
                        name="email"
                        type="string"
                        size="small"
                        value={values.email}
                        onChange={handleChange}
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email}
                      />
                    </Grid>

                    {!formData?.id && (
                      <>
                        <Grid item sm={12} md={12}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="password"
                            label={getTranslation(
                              "Password",
                              "Mot de passe",
                              "Passwort"
                            )}
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            error={touched.password && Boolean(errors.password)}
                            helperText={touched.password && errors.password}
                          />
                        </Grid>
                        <Grid item sm={12} md={12}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="password"
                            label={getTranslation(
                              "Confirm Password",
                              "Confirmer le mot de passe",
                              "Passwort bestätigen"
                            )}
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onChange={handleChange}
                            error={
                              touched.confirmPassword &&
                              Boolean(errors.confirmPassword)
                            }
                            helperText={
                              touched.confirmPassword && errors.confirmPassword
                            }
                          />
                        </Grid>
                      </>
                    )}

                    <Grid item sm={12} md={12}>
                      <CountrySelection
                        label={getTranslation("Country", "Country", "Country")}
                        name="country"
                        required
                        disabled={values.packageType === 1}
                        selected={values.country}
                        onChange={(e, value) => {
                          setFieldValue("country", value);
                        }}
                        error={touched.country && Boolean(errors.country)}
                        helperText={touched.country && errors.country}
                      />
                    </Grid>

                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation("Address", "Address", "Address")}
                        name="address1"
                        type="string"
                        size="small"
                        value={values.address1}
                        onChange={handleChange}
                        error={touched.address1 && Boolean(errors.address1)}
                        helperText={touched.address1 && errors.address1}
                      />
                    </Grid>

                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation("Zip", "Zip", "Zip")}
                        name="zipCode"
                        type="string"
                        size="small"
                        value={values.zipCode}
                        onChange={handleChange}
                        error={touched.zipCode && Boolean(errors.zipCode)}
                        helperText={touched.zipCode && errors.zipCode}
                      />
                    </Grid>

                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation("VAT", "VAT", "VAT")}
                        name="vat"
                        type="string"
                        size="small"
                        value={values.vat}
                        onChange={handleChange}
                        error={touched.vat && Boolean(errors.vat)}
                        helperText={touched.vat && errors.vat}
                      />
                    </Grid>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation("phone", "phone", "phone")}
                        name="phone"
                        type="string"
                        size="small"
                        value={values.phone}
                        onChange={handleChange}
                        error={touched.phone && Boolean(errors.phone)}
                        helperText={touched.phone && errors.phone}
                      />
                    </Grid>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation("Town", "Town", "Town")}
                        name="town"
                        type="string"
                        size="small"
                        value={values.town}
                        onChange={handleChange}
                        error={touched.town && Boolean(errors.town)}
                        helperText={touched.town && errors.town}
                      />
                    </Grid>

                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation(
                          "Resturant Name",
                          "Resturant Name",
                          "Resturant Name"
                        )}
                        name="name"
                        type="string"
                        size="small"
                        value={values.name}
                        onChange={handleChange}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>

                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation(
                          "Resturant Description",
                          "Resturant Description",
                          "Resturant Description"
                        )}
                        name="description"
                        type="string"
                        size="small"
                        value={values.description}
                        onChange={handleChange}
                        error={
                          touched.description && Boolean(errors.description)
                        }
                        helperText={touched.description && errors.description}
                      />
                    </Grid>

                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label={getTranslation("Resturant Website (without http)")}
                        name="website"
                        type="string"
                        size="small"
                        placeholder="google.com"
                        value={values.website}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.website && Boolean(errors.website)}
                        helperText={touched.website && errors.website}
                      />
                    </Grid>

                    <Grid item sm={12} md={12}>
                      <ButtonWithLoading
                        type="submit"
                        loading={isSubmitting}
                        onClick={handleSubmit}
                        title={
                          formData?.id
                            ? getTranslation("Update", "Update", "Update")
                            : getTranslation("Add", "Add", "Add")
                        }
                        variant="contained"
                        color="primary"
                        textColor="white"
                      />
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </CardContent>
      </Card>
    </MyDialog>
  );
};

export default Add;
